import IBAN from 'iban';

export const formatIban = (iban) => IBAN.printFormat(iban, ' ');

export const normaliseIban = (iban) => IBAN.electronicFormat(iban);
